import { LoadingButton } from '@mui/lab';
import { Card, Grid, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import Spinner from 'src/utils/Loader/spinner';
import { useToaster } from 'src/utils/toaster/toasterContext';
import dashboard from '../../assets/app-image/dashboard.svg';
import DashboardProfileStats from './dashboardProfileStats.component';
import RecentPosts from './recentPost.component';

const Dashboard = () => {
  const { t: translate } = useTranslation();

  const [loader, setLoader] = useState(true);
  const [height, setHeight] = useState(window.innerHeight - 110);
  const [dashboardData, setDashboardData] = useState([]);
  const [dashboardProfileStats, setDashboardProfileStats] = useState([]);
  const navigate = useNavigate();
  const { showToast } = useToaster();
  const theme = useTheme();
  const hasIntegratePermission = CommonHelper.CheckForPermissionAvailableForUser(
    CommonHelper.PermissionList.INTEGRATE_PERMISSION
  );
  useEffect(() => {
    getDashboardData();
  }, []);

  const getDashboardData = () => {
    let mediaProps = {
      url: userModuleURL.getDashboardData,
      successCallback,
      failureCallback,
    };
    HttpServices.Get(mediaProps);
  };

  const successCallback = (data) => {
    setLoader(false);
    setDashboardData(data.recent_posts);
    setDashboardProfileStats(data.dashbaord_profile_stats);
  };

  const failureCallback = (message) => {
    setLoader(false);
    message && showToast(message, 'e');
  };

  const navigateToIntegration = () => {
    navigate('/integration');
  };

  const isEmptyData = (data) => {
    return Object.values(data).every((arr) => arr.length === 0);
  };

  return (
    <>
      <Helmet>
        <title>{translate('navbar.menu.dashboard')}</title>
      </Helmet>
      {loader ? (
        <Spinner height={height} />
      ) : (
        <>
          <Grid
            container
            sx={{
              ...(!isEmptyData(dashboardData) &&
                !isEmptyData(dashboardProfileStats) && {
                  minHeight: 'calc(100vh - 100px)',
                  maxHeight: 'calc(100vh - 100px)',
                  overflowY: 'auto',
                }),
            }}
          >
            {dashboardProfileStats && !isEmptyData(dashboardProfileStats) && (
              <>
                <Typography variant="h5" sx={{ mb: 2 }}>
                  {translate('dashboard.profile_status')}
                </Typography>
                <Grid
                  container
                  direction="row"
                  wrap="nowrap"
                  style={{
                    overflowX: 'auto',
                    scrollbarWidth: 'thin',
                    scrollbarColor: `${theme.palette.primary.main} ${theme.palette.secondary.lighter}`,
                    minHeight: 'calc(15vh - 15px)',
                    maxHeight: 'calc(20vh - 20px)',
                  }}
                >
                  {Object.keys(dashboardProfileStats).map(
                    (serviceKey, index) =>
                      dashboardProfileStats[serviceKey] &&
                      dashboardProfileStats[serviceKey].map((service, serviceIndex) => (
                        <Grid
                          item
                          key={serviceIndex}
                          sx={{ minWidth: 250, flexGrow: 1, flexShrink: 0, minHeight: 100, pr: 1, pt: 0.5, pb: 1 }}
                        >
                          {service && <DashboardProfileStats service={service} serviceName={serviceKey} />}
                        </Grid>
                      ))
                  )}
                </Grid>
              </>
            )}
            {dashboardData && !isEmptyData(dashboardData) && (
              <>
                <Typography variant="h5" sx={{ mt: 1, mb: 2 }}>
                  {translate('dashboard.recent_posts')}
                </Typography>
                <Grid
                  container
                  direction="row"
                  wrap="nowrap"
                  style={{
                    overflowX: 'auto',
                    scrollbarWidth: 'thin',
                    overflowY: 'hidden',
                    scrollbarColor: `${theme.palette.primary.main} ${theme.palette.secondary.lighter}`,
                    minHeight: 'calc(70vh - 70px)',
                    maxHeight: 'calc(85vh - 85px)',
                  }}
                >
                  {Object.keys(dashboardData).map(
                    (serviceKey, index) =>
                      dashboardData[serviceKey] &&
                      dashboardData[serviceKey].map((service, serviceIndex) => (
                        <Grid
                          item
                          key={serviceIndex}
                          sx={{
                            minWidth: 360,
                            minHeight: 100,
                            pr: 1,
                            pt: 0.5,
                            mb: 3,
                          }}
                        >
                          {service && service.posts && <RecentPosts service={service} serviceName={serviceKey} />}
                        </Grid>
                      ))
                  )}
                </Grid>
              </>
            )}
          </Grid>

          {isEmptyData(dashboardData) && isEmptyData(dashboardProfileStats) && (
            <Card
              sx={{
                mb: 2,
                p: 2,
                height: height,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 'calc(100vh - 100px)',
                maxHeight: 'calc(100vh - 100px)',
              }}
            >
              <img
                src={dashboard}
                style={{ width: '50%', height: '50%', maxWidth: '50%', maxHeight: '50%' }}
                alt="No Dashboard"
              />
              {hasIntegratePermission && (
                <LoadingButton variant="contained" autoFocus onClick={navigateToIntegration} sx={{ mt: -5 }}>
                  {translate('common.connect_your_social_accounts')}
                </LoadingButton>
              )}
            </Card>
          )}
        </>
      )}
    </>
  );
};

export default Dashboard;
